/**
 * Shared map from the raw taxonomy label used in the ranking data to the
 * name shown to readers. Used by the homepage index and the list pages so
 * both always show the same name. Slugs are never derived from this map.
 */
export const DISPLAY_NAME: Record<string, string> = {
  Accounting: "Accounting",
  "Aerospace/Defense": "Aerospace & Defense",
  AgricultureLivestock: "Agriculture & Livestock",
  "Apparel&Stores": "Apparel & Retail",
  AutoManufacturing: "Auto Manufacturing",
  "Banks-Community/Regional": "Community & Regional Banks",
  "Biotechnology/LifeSciences": "Biotechnology & Life Sciences",
  BuildingMaterials: "Building Materials",
  BusinessProcessOutsourcing: "Business Process Outsourcing",
  "Chemicals/AlliedProducts": "Chemicals & Allied Products",
  "CleanTech/EnergyTech": "CleanTech & Energy Tech",
  "Cloud/Networks": "Cloud & Networks",
  "ComputerHardware/MobileDevices/Wearables": "Computer Hardware, Mobile Devices & Wearables",
  Consulting: "Consulting",
  ConsumerProducts: "Consumer Products",
  Container: "Containers & Packaging",
  "DigitalMedia/Photos/Publishing": "Digital Media & Publishing",
  Distribution: "Distribution",
  EducationServices: "Education Services",
  "Electrical/Electronic": "Electrical & Electronics",
  EnergyServices: "Energy Services",
  EnterpriseSoftware: "Enterprise Software",
  Environmental: "Environmental Services",
  "Food&Beverage": "Food & Beverage",
  "Gaming/Gambling": "Gaming & Gambling",
  HealthCenters: "Health Centers & Clinics",
  HealthInfoTech: "Health Information Technology",
  InformationTech: "Information Technology",
  Insurance: "Insurance",
  "IT Services": "IT Services",
  Legal: "Legal Services",
  Leisure: "Leisure & Hospitality",
  Logistics: "Logistics",
  MachineryEquipment: "Machinery & Equipment",
  Media: "Media",
  "MedicalDevices/Diagnostics": "Medical Devices & Diagnostics",
  MedicalEquipmentSupplies: "Medical Equipment & Supplies",
  MedicalServices: "Medical Services",
  MiningMetals: "Mining & Metals",
  "Oil&Gas-UpStream": "Oil & Gas (Upstream)",
  "ProgrammingTools/Developers/Websites": "Developer Tools & Web Platforms",
  "RealEstate(PropertyManagement/Brokerage)":
    "Real Estate Services (Property Management & Brokerage)",
  Restaurants: "Restaurants",
  Security: "Security",
  SemiConductor: "Semiconductors",
  "Social/BusinessNetworks": "Social & Business Networks",
  Software: "Software",
  Staffing: "Staffing",
  Telecommunications: "Telecommunications",
  TraditionalAssetManagement: "Traditional Asset Management",
  TruckTransportation: "Trucking & Freight",
  WaterTransportation: "Shipping & Water Transportation",
  "Crypto, Blockchain, Tokenization": "Crypto, Blockchain & Tokenization",
  "Gaming and Interactive Entertainment": "Gaming & Interactive Entertainment",
};

export const STAGE_LABEL: Record<string, string> = {
  Seed: "Seed",
  "Early Stage": "Early Stage",
  "Later Stage": "Later Stage",
  PE: "Private Equity",
};

/** Lowercase stage phrase used inside sentences. */
export const STAGE_PHRASE: Record<string, string> = {
  Seed: "seed",
  "Early Stage": "early stage",
  "Later Stage": "later stage",
  PE: "private equity",
};

export function displayName(category: string): string {
  return DISPLAY_NAME[category] ?? category;
}

export function listTitle(stage: string, category: string): string {
  return `Top 10 ${STAGE_LABEL[stage] ?? stage} Investors in ${displayName(category)}`;
}

export function listMetaDescription(stage: string, category: string): string {
  return `The most active ${STAGE_PHRASE[stage] ?? stage} investors in ${displayName(category)}, ranked by 2025/2026 deal activity and matched to the CapitalDart investor directory.`;
}
